import React from 'react';
import { string, shape, bool } from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import { connect, Provider } from 'react-redux';
import { Loader } from '@tesla/design-system-react';
import { SiteFooter, TtpProvider } from '@tesla/tw-react';
import Content from './pages';
import Selectors from './common/redux/selectors';

import '@tesla/design-system/dist/index.css';
import '@tesla/tw-react/dist/index.css';

import styles from './App.module.css';

const propTypes = {
  store: shape({}).isRequired,
  ttp: shape({}).isRequired,
  initialData: shape({
    header: shape({
      endpoint: string.isRequired,
      locale: string.isRequired,
    }),
    locale: string.isRequired,
  }).isRequired,
  baseRoute: string.isRequired,
  showLoader: bool.isRequired,
};

const App = ({
  // Props
  baseRoute,
  store,
  ttp,
  // Selectors
  showLoader,
  initialData,
}) => {
  const { locale } = initialData;
  return (
    <Provider store={store}>
      <TtpProvider value={ttp}>
        <div className={styles.AppWrapper}>
          <BrowserRouter basename={baseRoute}>
            <Loader fullscreen show={showLoader} />
            <div id="main-content" className={styles.AppWrapper}>
              <Content />
            </div>
          </BrowserRouter>
        </div>
        <SiteFooter locale={locale} />
      </TtpProvider>
    </Provider>
  );
};
App.propTypes = propTypes;

export default connect(Selectors)(App);
